// The `Game` the chrome draws from — one per store, provided beside it.
//
// `BoardCanvas` takes a `Game` and nothing else about the rules (PLAN-CLIENT-
// SPLIT days 3–4). The app builds one over its store where the store is made
// and provides it here; a page with a store of its own does the same. The
// human tree's `useGame` (day 5) replaces this once `src/main.tsx` composes
// the two, which is why this stays a thin context and not a subscription.

import { createContext, useContext } from "react";

import type { EngineGame } from "src/engine/api/createGame";

// The engine's `Game` rather than the contract's, for the week the chrome still
// reads the session's `interaction()`; day 8 narrows it to `src/api`'s.
export const GameContext = createContext<EngineGame | null>(null);

export function useGame(): EngineGame {
  const game = useContext(GameContext);
  if (!game) throw new Error("useGame outside GameContext");
  return game;
}
